import React from 'react';
import HistoryIcon from '@mui/icons-material/History';

const StatusHistoryLog = ({ history = [] }) => (
  <div>
    <h4 className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1.5">
      <HistoryIcon style={{ fontSize: 16 }} /> Movement History
    </h4>
    <div className="space-y-1.5 max-h-44 overflow-y-auto">
      {history.length === 0 && <p className="text-xs text-gray-400 italic">No history yet.</p>}
      {history.map((h) => (
        <div key={h.id} className="flex items-start gap-2 text-xs text-gray-600">
          <div className="w-1.5 h-1.5 rounded-full bg-[#002169] mt-1.5 flex-shrink-0" />
          <div>
            <span className="font-medium text-gray-800">
              {h.to_column_label || h.to_column_key || '—'}
            </span>
            {h.from_column_label && (
              <span className="text-gray-400"> from {h.from_column_label}</span>
            )}
            {h.note && (
              <span className="text-gray-400 italic"> · {h.note}</span>
            )}
            <span className="text-gray-400 ml-1">
              · {h.moved_by_name || 'System'} ·{' '}
              {new Date(h.moved_at).toLocaleDateString('en-AU', {
                day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
              })}
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default StatusHistoryLog;
